export const TLC_CONSTANTS = {
	Events: {
		onClickSearch: 'onClickSearch',
		onPagingModelResponse: 'onPagingModelResponse',
		onClickPrevResultPage: 'onClickPrevResultPage',
		onClickNextResultPage: 'onClickNextResultPage',
		onClickSkipToResultPage: 'onClickSkipToResultPage',
		onClickSortResults: 'onClickSortResults',
		onRequestFirstPage: 'onRequestFirstPage',
		onSelectResult: 'onSelectResult',
		onSelectAll: 'onSelectAll',
		onRemoveResultSelection: 'onRemoveResultSelection',
		onRemoveAllSelection: 'onRemoveAllSelection',
		onRequestSelectedResults: 'onRequestSelectedResults',
		onSelectedResultsResponse: 'onSelectedResultsResponse',
		noHistoryFound: 'noHistoryFound'
	},
	CssClasses: {
		nextButton: 'next',
		prevButton: 'prev',
		error: 'error',
		success: 'success',
		disabled: 'disabled',
		required: 'required'
	},
	ValidatorType: {
		zipCode: 'zipCode',
		phoneNumber: 'phoneNumber',
		email: 'email',
		match: 'match'
	},
	ids: {
		mainNavBar: "mainNavBar",
		main: "main",
		dialogs: "dialogs",
		messaging: "messaging",
		areYouSurePromptDialog:"areYouSurePromptDialog",
		hiddenIFrameDownloader:"hiddenIFrameDownloader"
	}
};